// this file is automatically generated by git.revision.js script
export const versions = { revision: '10efbd388f' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '10efbd388f';
